import { render, staticRenderFns } from "./RankingPersonnel.vue?vue&type=template&id=392a67fa&scoped=true"
import script from "./RankingPersonnel.vue?vue&type=script&lang=js"
export * from "./RankingPersonnel.vue?vue&type=script&lang=js"
import style0 from "./RankingPersonnel.vue?vue&type=style&index=0&id=392a67fa&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392a67fa",
  null
  
)

export default component.exports